module.exports = __webpack_public_path__ + "media/images/athletes/1567-62eb8b6e87aa1856905db0804ae0a4ab.png";